import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';

interface Props {
  toc: { id: string; label: string }[];
  related: Article[];
}

export default function ArticleAside({ toc, related }: Props) {
  return (
    <aside className="lg:col-span-4">
      <div className="lg:sticky lg:top-28 space-y-6">
        <div className="rounded-lg border border-background-200 bg-background-100 p-6">
          <h2 className="font-heading font-bold text-base text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-list-check-2 text-primary-600"></i>
            本文目录
          </h2>
          <nav aria-label="文章目录">
            <ul className="space-y-1">
              {toc.map((item, i) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="flex items-start gap-2 py-1.5 text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    <span className="text-xs text-foreground-400 mt-0.5">{String(i + 1).padStart(2, '0')}</span>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {related.length > 0 && (
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading font-bold text-base text-foreground-950 mb-4">相关推荐</h2>
            <ul className="space-y-4">
              {related.map((a) => (
                <li key={a.id}>
                  <Link to={`/article/${a.id}`} className="group flex gap-3 cursor-pointer">
                    <span className="shrink-0 w-16 h-16 rounded-md overflow-hidden bg-background-200">
                      <img
                        src={a.cover}
                        alt={`${a.title} - 17爆料网相关推荐`}
                        title={`${a.title} - 17爆料网`}
                        className="w-full h-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                        {a.title}
                      </span>
                      <span className="mt-1 block text-xs text-foreground-500">{a.date}</span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-6">
          <h2 className="font-heading font-bold text-base text-foreground-950">有更细的线索？</h2>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
            如果你掌握更具体的信息，欢迎匿名补充，我们会在核实后更新这条时间线。
          </p>
          <Link
            to="/contact"
            className="mt-4 inline-flex items-center gap-2 h-10 px-4 rounded-md bg-accent-600 text-background-50 text-sm font-medium hover:bg-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-send-plane-line"></i>
            补充线索
          </Link>
        </div>
      </div>
    </aside>
  );
}